export const HIDE_CATEGORY_CARD = 'hide-card';

export const SHOW_CATEGORY_CONTENT = 'show-content';

export const categoryAttributes = {
  keys: {
    cardIndex: 'data_card_index',
    elementType: 'data-category-element-type',
    parentSlug: 'data_parent_slug',
  },
  values: {
      categoryCard: 'category-card',
      categoryImage: 'category-image',
      categoryDetails: 'category-details',
      categoryLinks: 'category-links',
      moreCategories: 'more-categories',
  },
};
